import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../../config";
import { useLanguage } from "../../Context";

export default function News() {
  const [items, setItems] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { language } = useLanguage();

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=7&categoryid=4&subcategory=0&limitCount=4&lang=${language}`
    )
      .then((response) => response.json())
      .then((items) => {
        setItems(items);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [language]);

  // Loader before data is loaded
  if (isLoading) {
    return (
      <div className="max-container-width py-3">
        <div className="bg-body-secondary p-3 d-flex flex-column flex-md-row">
          <div className="col-md-5 bg-body-secondary">
            <span className="placeholder col-12" style={{ height: "70%" }} />
            <span className="placeholder col-6" />
            <span className="placeholder col-12" />
            <span className="placeholder col-12" />
            <span className="placeholder col-5" />
          </div>
          <div className="col-md-7 placeholder-glow">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="d-flex p-3 gap-3">
                <div className="col-4 placeholder"></div>
                <div className="col-8">
                  <span
                    className="placeholder col-5 mb-2"
                    style={{ height: "2rem" }}
                  />
                  <span className="placeholder col-12 mb-2" />
                  <span className="placeholder col-12 mb-2" />
                  <span className="placeholder col-7 mb-2" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // error if data is not fetched
  if (error) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <p className="alert alert-danger" role="alert" dir="ltr">
          Something went wrong: {error.message}
        </p>
      </div>
    );
  }

  const lastArrayElement = items.slice(0, 1);
  const latestNews = lastArrayElement.map((news) => (
    <Link
      key={news.id}
      to={`/${news.CategoryE}/${news.SubCategory}/${news.id}`}
      className="col-md-5 card p-3 border-0 rounded-none bg-body-secondary blue-links"
    >
      <img src={news.ImageUrl} className="mb-2" alt="..." />
      <h5 className="card-title primary-text-blue">{news.Title}</h5>
      <p className="card-text primary-text-blue limit-text">{news.ShortDesc}</p>
    </Link>
  ));

  return (
    <>
      <div className="max-container-width py-3 primary-text-blue">
        <div className="d-flex justify-content-between align-items-center mb-2 dash-divider">
          <h3
            className="border-end border-5 pe-2 ps-1 bg-body"
            id="secondary-border-yellow"
          >
            امت نیوز
          </h3>
          <Link
            to="/news"
            className="d-flex gap-2 align-items-center primary-text-blue pe-1 bg-body"
          >
            <strong className="m-0 p-0">
              {parseInt(language) === 1 ? "مجموع مقالات" : "ټول مقالات"}
            </strong>
            <img
              src="/img/arrow.png"
              style={{ width: "1.7em", transform: "rotate(180deg)" }}
              alt=""
            />
          </Link>
        </div>
        <div className="bg-body-secondary d-flex flex-column flex-md-row">
          {latestNews}
          <div className="col-md-7">
            {items.slice(1).map((news) => (
              <Link
                key={news.id}
                to={`/${news.CategoryE}/${news.SubCategory}/${news.id}`}
                className="d-flex p-3 gap-3 primary-text-blue blue-links"
              >
                <img
                  style={{ maxWidth: "13.5rem", maxHeight: "7.5rem" }}
                  className="col-4 object-fit-cover"
                  src={news.ImageUrl}
                  alt=""
                />
                <div className="col-8">
                  <h4>{news.Title}</h4>
                  <p className="limit-text">{news.ShortDesc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
